import Button from "../base/Button";

const renderIcon = (color) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
    >
        <g
            fill="none"
            fillRule="evenodd"
            stroke={color}
            strokeLinecap="square"
            strokeWidth="2"
            transform="translate(1.862 2)"
        >
            <path d="M11.429 5.714h9.142L16 0zM26.286 11.429v9.142L32 16zM20.571 26.286H11.43L16 32zM5.714 20.571V11.43L0 16z" />
            <circle cx="16" cy="16" r="3.429" />
        </g>
    </svg>
);

/**
 * Toolbar button for the move tool with a 4-directional arrow icon.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered move button.
 */
const MoveButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default MoveButton;
